const comparisonData = [
  { label: "Экономия", yoybuy: 5, kakobuy: 4, superbuy: 3 },
  { label: "Скорость обработки", yoybuy: 5, kakobuy: 4, superbuy: 3 },
  { label: "Удобство Spreadsheet", yoybuy: 5, kakobuy: 4, superbuy: 3 },
  { label: "Надёжность", yoybuy: 5, kakobuy: 4, superbuy: 4 },
  { label: "Контроль заказа", yoybuy: "Полный", kakobuy: "Частичный", superbuy: "Ограниченный" },
];

function Stars({ count }: { count: number }) {
  return (
    <span className="text-accent-500 text-sm tracking-widest">
      {"★".repeat(count)}{"☆".repeat(5 - count)}
    </span>
  );
}

export default function ComparisonSection() {
  return (
    <section className="py-10 md:py-16 bg-background-100">
      <div className="w-full px-4 md:px-8 max-w-5xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-3">
          YOYBUY vs KAKOBUY vs SUPERBUY
        </h2>
        <p className="text-foreground-600 mb-8">
          Честное сравнение агентов для покупок в Китае через Spreadsheet
        </p>

        <div className="overflow-x-auto">
          <table className="w-full border-collapse bg-white rounded-lg overflow-hidden border border-background-200">
            <thead>
              <tr className="bg-secondary-50">
                <th className="text-left px-4 py-3 text-sm font-semibold text-foreground-800 border-b border-background-200">
                  Критерий
                </th>
                <th className="text-left px-4 py-3 text-sm font-semibold text-primary-700 border-b border-background-200">
                  YOYBUY Spreadsheet
                </th>
                <th className="text-left px-4 py-3 text-sm font-semibold text-foreground-800 border-b border-background-200">
                  KAKOBUY Spreadsheet
                </th>
                <th className="text-left px-4 py-3 text-sm font-semibold text-foreground-800 border-b border-background-200">
                  SUPERBUY Spreadsheet
                </th>
              </tr>
            </thead>
            <tbody>
              {comparisonData.map((row, idx) => (
                <tr key={row.label} className={idx % 2 === 0 ? "bg-white" : "bg-background-50/50"}>
                  <td className="px-4 py-3 text-sm font-medium text-foreground-800 border-b border-background-100">
                    {row.label}
                  </td>
                  <td className="px-4 py-3 text-sm text-foreground-700 border-b border-background-100">
                    {typeof row.yoybuy === "number" ? <Stars count={row.yoybuy} /> : row.yoybuy}
                  </td>
                  <td className="px-4 py-3 text-sm text-foreground-700 border-b border-background-100">
                    {typeof row.kakobuy === "number" ? <Stars count={row.kakobuy} /> : row.kakobuy}
                  </td>
                  <td className="px-4 py-3 text-sm text-foreground-700 border-b border-background-100">
                    {typeof row.superbuy === "number" ? <Stars count={row.superbuy} /> : row.superbuy}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-4">
          <div className="bg-primary-50 border border-primary-200 rounded-lg p-4">
            <p className="text-sm text-primary-900 font-medium">
              YOYBUY Spreadsheet показывает лучший баланс цены и контроля
            </p>
          </div>
          <div className="bg-secondary-50 border border-secondary-200 rounded-lg p-4">
            <p className="text-sm text-secondary-900 font-medium">
              KAKOBUY подходит для среднего бюджета
            </p>
          </div>
          <div className="bg-accent-50 border border-accent-200 rounded-lg p-4">
            <p className="text-sm text-accent-900 font-medium">
              SUPERBUY дороже при схожем функционале
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}